export default "__VITE_ASSET__9e5f4637__"